import { TaskType } from 'src/app/shared/enums';
import { MultistepProcessDetailsViewComponent } from '../components/jobs-tab/multistep-process-details-view/multistep-process-details-view.component';
import { ZCIndexingProcessDetailsViewComponent } from '../components/process-details-view/zc-indexing-process-details-view/zc-indexing-process-details-view.component';
import { ZCVCalcProcessDetailsViewComponent } from '../components/process-details-view/zcv-calc-process-details-view/zcv-calc-process-details-view.component';

export function processDetailViewComponentFactory(taskType: TaskType): any {
    switch (taskType) {
        case TaskType.ZONING_CODE_INDEXING:
        case TaskType.ZONING_CODE_INDEXING_WITH_CURSOR:
            return ZCIndexingProcessDetailsViewComponent;
        case TaskType.ZC_VERSION_CALCULATION:
            return ZCVCalcProcessDetailsViewComponent;
        default:
            return MultistepProcessDetailsViewComponent;
    }
}
